module.exports = __webpack_public_path__ + "img/frame_logo_emporio_armani.1ccd279f.png";